<template>
  <div>
    <div class="bg-gray-900 p-2 -mt-2">
      <span class="text-gray-300 text-sm">{{ $t('Not me:')}} </span>
      <transition-group name="list-complete">
        <div
          v-for="(card, index) in notmearray"
          :key="card.id"
          class="notcard"
        >
                <input type="hidden" id="MaybeMe">
                <button class="maybemebutton"  @click="MaybeMe(index, card)">{{ card.attributes['title'].text }}</button>
        </div>
      </transition-group>
    </div>
    <div class="comparison-wrapper">
        <transition-group name="list-reverse" class="comparison-responsive flex-row" tag="div">
          <div
            v-for="(card, index) in cards"
            :key="card.id"
            class="comparison-item text-center flex-col"
          >
              <input type="hidden" id="NotMe">
                  <button v-if="cards.length > 2" class="notmebutton" @click="NotMe(index, card)"><i aria-hidden="true" class="material-icons align-middle">close</i>Not Me</button>
                  <button id="submitFinal" v-if="cards.length < 3" class="btn btn-sm bg-yellow-600 hover:bg-yellow-800" @click="submitFinal(card.id)"><i aria-hidden="true" class="material-icons align-middle">check</i>Final Choice</button>
                <div class="attributes">
                    <div class="cell" v-for="attributes in card.attributes">
                      <span class="label">{{ attributes.label }}</span>
                      <span class="description" v-html="attributes.text"></span>
                    </div>
                </div>
          </div>
        </transition-group>
    </div>
    <div class="whitespace-no-wrap text-center">
      <div
          v-for="card in cards"
          :key="card.id"
          class="comparison-dots text-center inline-block text-xl text-gray-500"
        >
          .
      </div>
    </div> 
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
      array: '',
      merged: [],
      route:'',
  },
  data () {
    return {
      cards: this.array,
      notmearray: [],
    }
  },
  methods: {
    MaybeMe(index, card){
        this.cards.unshift(card);
        this.notmearray.splice(index, 1);
        console.log('Moved to Maybe Me');
    },
    NotMe(index, card){
        this.notmearray.unshift(card);
        this.cards.splice(index, 1);
        console.log('Moved to Not Me');
    },
    submitFinal(id) {
        $( "#submitFinal").addClass( "loading" );
        axios.put(this.route, { 
          results: [id] 
        }).then(function (response) {
            console.log(response);
          }).then(function (event) {
            location.reload();
          })
      },
  }
};
</script>
